import React from "react";
import horizontal from "../images/horizontal.png";

const ContactsMobile = () => {
	return (
		<>
			<div
				style={{
					display: "flex",
					flexDirection: "row",
					alignItems: "center",
					width: "90%",
					margin: "20% auto 2% auto",
				}}
			>
				<span style={{ color: "#C778DD" }}>#</span>
				<h3 style={{ color: "white", fontWeight: "bolder" }}>Contacts</h3>
				<img src={horizontal} alt="" style={{ width: "50%", height: "auto" }} />
			</div>

			<div style={{ color: "#ABB2BF", width: "90%", margin: "0 auto" }}>
				<p
					style={{ textAlign: "justify", textJustify: "auto", hyphens: "auto" }}
				>
					I would be happy to connect with you and discuss any
					blockchain-related projects or ideas you have. Please feel free to
					reach out to me at any time via email or LinkedIn. I look forward to
					hearing from you and potentially collaborating on exciting
					opportunities.
				</p>
			</div>
		</>
	);
};

export default ContactsMobile;
